import styled from 'styled-components';
import SectionLabelNormal from '../SectionLabelNormal';

const SectionLabelLight = styled(SectionLabelNormal)`
  opacity: 0.4;
`;

export default SectionLabelLight;
